import { styled } from '../../../../../../stitches.config';
import { Button } from '../../../../..';
import { FunctionalGroup, Group, Value } from './FunctionalGroup';

export type { Value } from './FunctionalGroup';

export type FunctionalGroupPanelProps = {
  name: string;
  subgroups: Group[];
  location: number;
  value: Value;
  onChange: (value: Value) => void;
  onNewPanelOpen: (group: Group) => void;
  onPreviousPanelOpen: () => void;
};

const Container = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$5',
});

const Grid = styled('div', {
  display: 'grid',
  gap: '$5',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gridAutoRows: '1fr',
});

export function FunctionalGroupPanel(props: FunctionalGroupPanelProps) {
  const { subgroups, location, value, onChange, onNewPanelOpen, onPreviousPanelOpen } = props;

  function onOpen(group: Group) {
    return () => onNewPanelOpen(group);
  }

  return (
    <Container>
      {location !== 0 && (
        <div>
          <Button size="small" weight="minimal" onClick={onPreviousPanelOpen} text="Back" icon="arrow_back" />
        </div>
      )}

      <Grid>
        {subgroups.map(group => (
          <div key={group.name}>
            <FunctionalGroup group={group} value={value} onChange={onChange} onOpen={onOpen(group)} />
          </div>
        ))}
      </Grid>
    </Container>
  );
}
